import { render } from "./LoginPage_Staff.vue?vue&type=template&id=9c0a94ec&scoped=true"
import script from "./LoginPage_Staff.vue?vue&type=script&lang=js"
export * from "./LoginPage_Staff.vue?vue&type=script&lang=js"

import "./LoginPage_Staff.vue?vue&type=style&index=0&id=9c0a94ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0a94ec"]])

export default __exports__